import {TimeFormat, toFrames} from '@accurate-player/accurate-player-core';
import {curry} from 'ramda';
import {useEffect} from 'react';
import {AdPreview} from 'VideoAudioQC/AccuratePlayer/AccuratePlayerTypes';
import {SetAdOnPlayingFrame} from 'VideoAudioQC/AccuratePlayer/Redux/AccuratePlayerActions';
import {Item} from 'VideoAudioQC/QCMedia/Redux/QCMediaActions';
import {TimelineMarker} from 'VideoAudioQC/Timeline/TimelineTypes';
import wrap from 'wraptile';

export interface AdOnPlayingFrameContainerProps {
    item: Item;
    adBreaks: TimelineMarker[];
    adPreviews?: AdPreview[];
    adOnPlayingFrame?: TimelineMarker,
    currentTime: number;
    paused: boolean;
    setAdOnPlayingFrame: SetAdOnPlayingFrame;
}

export const compareAdBreakFrame = curry((currentFrame: number, adBreak: TimelineMarker) => {
    return adBreak.start === currentFrame;
});

export const getCurrentFrame = curry((props: AdOnPlayingFrameContainerProps) => {
    const {
        item,
        currentTime,
    } = props;
    const {
        frameRate,
        dropFrame,
        duration,
    } = item.video;
    const {
        numerator,
        denominator,
    } = frameRate;
    const frameRateValue = numerator / denominator;
    const currentFrame = toFrames(
        currentTime,
        TimeFormat.Seconds,
        frameRateValue,
        dropFrame,
        duration,
    );
    
    return currentFrame;
});

export const setPlayingAd = wrap((props: AdOnPlayingFrameContainerProps) => {
    const {
        adBreaks,
        adPreviews,
        adOnPlayingFrame,
        paused,
        setAdOnPlayingFrame,
    } = props;
    
    if (adPreviews !== undefined || adBreaks.length === 0 || !paused) {
        if (adOnPlayingFrame)
            setAdOnPlayingFrame(undefined);
        
        return;
    }
    
    const currentFrame = getCurrentFrame(props);
    const adBreakOnFrame = adBreaks.find(compareAdBreakFrame(currentFrame));
    
    if (adBreakOnFrame) {
        setAdOnPlayingFrame(adBreakOnFrame);
    } else if (adOnPlayingFrame) {
        setAdOnPlayingFrame(undefined);
    }
});

export default function AdOnPlayingFrameContainer(props: AdOnPlayingFrameContainerProps) {
    const {
        adBreaks,
        adPreviews,
        adOnPlayingFrame,
        paused,
        currentTime,
    } = props;
    const handleSetPlayingAd = setPlayingAd(props);
    
    useEffect(handleSetPlayingAd, [adBreaks, adPreviews, adOnPlayingFrame, paused, currentTime]);
    
    return null;
}
